export default __webpack_public_path__ + "static/media/visa.8064c1a6.png";